import { API_BASE_URL } from "src/config/apiBase";
import { useEffect, useState } from "react";
import axios from "axios";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from "../utils/getCookie";

function FooterSetting() {
    const [form, setForm] = useState({
        main_id: "",
        company_name: "",
        about_text: "",
        quick_links: [],
        policies: [],
        details: [],
        email: "",
        phone: "",
        address: "",
        social_links: {
            facebook: "",
            instagram: "",
            twitter: "",
            linkedin: ""
        },
        quick_links_heading: "Quick Links",
        policies_heading: "Policies",
        show_copyright: true,
        copyright_text: "Designed by 100billion Tech",
        status: "Active",
        details_name: "Get in Touch"
    });
    const urlmain = API_BASE_URL
    const token = decryptToken("accessToken");
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [copyright, setCopyRight] = useState(false)

    const parseIfString = (value, fallback) => {
        if (!value) return fallback;

        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch {
                return fallback;
            }
        }

        return value;
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSocialChange = (e) => {
        setForm({
            ...form,
            social_links: {
                ...form.social_links,
                [e.target.name]: e.target.value
            }
        });
    };

    const addLink = (type) => {
        setForm({
            ...form,
            [type]: [...form[type], { label: "", url: "" }]
        });
    };

    const handleLinkChange = (type, index, field, value) => {
        const updated = [...form[type]];
        updated[index][field] = value;
        setForm({ ...form, [type]: updated });
    };

    const addContact = () => {
        setForm({
            ...form,
            details: [...form.details, { label: "", value: "" }]
        });
    };

    const removeContact = (index) => {
        const updated = [...form.details];
        updated.splice(index, 1);
        setForm({
            ...form,
            details: updated
        });
    };

    const handleContactChange = (index, field, value) => {
        const updated = [...form.details];
        updated[index][field] = value;

        setForm({
            ...form,
            details: updated
        });
    };


    const saveFooter = async () => {
        try {
            const res = await axios.post(
                `${urlmain}/footer`,
                form,
                {
                    headers: {
                        ...(token ? { Authorization: `Bearer ${token}` } : {}),
                        "Content-Type": "application/json"
                    }
                }
            );
            console.log(res);
            if (res.status === 200) {
                toast.success(`${res.data.message}`)
            } else {
                toast.error("Error Occured")
            }

        } catch (error) {
            console.error("Save footer failed", error);
            toast.error("Failed to save footer");
        }
    };


    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${urlmain}/register/single/${isLoggedIn.main_id}`, {
                method: "GET",
                headers: {
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
            });
            const res = await response.json();
            console.log(res);
            setCopyRight(res.users.copyrightto_admin)
            // setUserData(res.users);
            // setFormData(res.users);
            // setOriginalFormData(res.users);
        } catch (error) {
            console.error(error);
        }
    };


    const removeLink = (type, index) => {
        const updated = [...form[type]];
        updated.splice(index, 1);
        setForm({ ...form, [type]: updated });
    };

    const fetchFooter = async () => {
        try {
            const res = await axios.get(
                `${urlmain}/footer`,
                {
                    headers: {
                        ...(token ? { Authorization: `Bearer ${token}` } : {}),
                        "Content-Type": "application/json"
                    }
                }
            );

            if (res.data?.data) {
                const data = res.data.data;

                const parsedQuickLinks = parseIfString(data.quick_links, []);
                const parsedPolicies = parseIfString(data.policies, []);
                const parsedSocials = parseIfString(data.social_links, {});
                const parsedContacts = parseIfString(data.details, []);




                setForm({
                    main_id: data.main_id || "",
                    company_name: data.company_name || "",
                    about_text: data.about_text || "",
                    quick_links: Array.isArray(parsedQuickLinks) ? parsedQuickLinks : [],
                    policies: Array.isArray(parsedPolicies) ? parsedPolicies : [],
                    email: data.email || "",
                    phone: data.phone || "",
                    address: data.address || "",
                    quick_links_heading: data?.quick_links_heading || "Quick Links",
                    policies_heading: data?.policies_heading || "Policies",
                    details_name:data?.details_name || "Get in touch",
                    social_links: {
                        facebook: parsedSocials.facebook || "",
                        instagram: parsedSocials.instagram || "",
                        twitter: parsedSocials.twitter || "",
                        linkedin: parsedSocials.linkedin || ""
                    },
                    details: Array.isArray(parsedContacts)
                        ? parsedContacts
                        : [],
                    show_copyright: data.show_copyright ?? true,
                    copyright_text:
                        data.copyright_text || "Designed by 100billion Tech",
                    status: data.status || "Active"
                });
            }
        } catch (error) {
            console.error("Failed to fetch footer", error);
        }
    };



    useEffect(() => {
        fetchFooter();
        fetchSingleuser();
    }, []);


    return (
        <div >
            <div className="oms-header">
                <h1 className="dashboard-title">Footer Setting</h1>

                {/* Add Offers Button */}

            </div>
            <div className="footersetting-container">


                <div className="footersetting-card">
                    {/* <label>Main ID</label>
                    <input name="main_id" onChange={handleChange} /> */}

                    <label>Company Name</label>
                    <input name="company_name" value={form.company_name} onChange={handleChange} />

                    <label>About Text</label>
                    <textarea name="about_text" value={form.about_text} onChange={handleChange} />
                </div>

                <div className="footersetting-card">
                    <h3
                        className="footersetting-heading"
                        contentEditable
                        suppressContentEditableWarning
                        onBlur={(e) =>
                            setForm({ ...form, quick_links_heading: e.target.innerText })
                        }
                    >
                        {form.quick_links_heading}
                    </h3>


                    {form.quick_links.length === 0 && (
                        <p className="footersetting-empty">No quick links added yet</p>
                    )}

                    {form.quick_links.map((link, i) => (
                        <div className="footersetting-row" key={i}>
                            <input
                                placeholder="Label"
                                value={link.label}
                                onChange={(e) =>
                                    handleLinkChange("quick_links", i, "label", e.target.value)
                                }
                            />
                            <input
                                placeholder="URL"
                                value={link.url}
                                onChange={(e) =>
                                    handleLinkChange("quick_links", i, "url", e.target.value)
                                }
                            />

                            <button
                                type="button"
                                className="footersetting-remove-btn"
                                onClick={() => removeLink("quick_links", i)}
                                title="Remove link"
                            >
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    ))}

                    <button
                        className="footersetting-btn"
                        onClick={() => addLink("quick_links")}
                    >
                        + Add Link
                    </button>
                </div>


                <div className="footersetting-card">
                    <h3
                        className="footersetting-heading"
                        contentEditable
                        suppressContentEditableWarning
                        onBlur={(e) =>
                            setForm({ ...form, policies_heading: e.target.innerText })
                        }
                    >
                        {form.policies_heading}
                    </h3>


                    {form.policies.length === 0 && (
                        <p className="footersetting-empty">No policies added yet</p>
                    )}

                    {form.policies.map((link, i) => (
                        <div className="footersetting-row" key={i}>
                            <input
                                placeholder="Label"
                                value={link.label}
                                onChange={(e) =>
                                    handleLinkChange("policies", i, "label", e.target.value)
                                }
                            />
                            <input
                                placeholder="URL"
                                value={link.url}
                                onChange={(e) =>
                                    handleLinkChange("policies", i, "url", e.target.value)
                                }
                            />

                            <button
                                type="button"
                                className="footersetting-remove-btn"
                                onClick={() => removeLink("policies", i)}
                            >
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    ))}

                    <button
                        className="footersetting-btn"
                        onClick={() => addLink("policies")}
                    >
                        + Add Policy
                    </button>
                </div>


                <div className="footersetting-card">
                    <h3
                        className="footersetting-heading"
                        contentEditable
                        suppressContentEditableWarning
                        onBlur={(e) =>
                            setForm({ ...form, details_name: e.target.innerText })
                        }
                    >
                        {form.details_name}
                    </h3>

                    {form.details.length === 0 && (
                        <p className="footersetting-empty">
                            No contact fields added yet
                        </p>
                    )}

                    {form.details.map((item, i) => (
                        <div className="footersetting-row" key={i}>
                            <input
                                placeholder="Label (Ex. Email, Phone, Address)"
                                value={item.label}
                                onChange={(e) =>
                                    handleContactChange(i, "label", e.target.value)
                                }
                            />

                            <input
                                placeholder="Value"
                                value={item.value}
                                onChange={(e) =>
                                    handleContactChange(i, "value", e.target.value)
                                }
                            />

                            <button
                                type="button"
                                className="footersetting-remove-btn"
                                onClick={() => removeContact(i)}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    ))}

                    <button
                        className="footersetting-btn"
                        onClick={addContact}
                    >
                        + Add Contact
                    </button>
                </div>


                <div className="footersetting-card">
                    <h3>Social Links</h3>
                    <input placeholder="Facebook" name="facebook" value={form.social_links.facebook} onChange={handleSocialChange} />
                    <input placeholder="Instagram" name="instagram" value={form.social_links.instagram} onChange={handleSocialChange} />
                    <input placeholder="Twitter" name="twitter" value={form.social_links.twitter} onChange={handleSocialChange} />
                    <input placeholder="LinkedIn" name="linkedin" value={form.social_links.linkedin} onChange={handleSocialChange} />
                </div>

                {
                    copyright ? <div className="footersetting-card footersetting-checkbox">
                        <label>

                            Show Copyright
                        </label>

                        {form.show_copyright && (
                            <input
                                placeholder="Copyright Text"
                                name="copyright_text"
                                value={form.copyright_text}
                                onChange={handleChange}
                            />
                        )}
                    </div> : null
                }


                <button className="footersetting-save-btn" onClick={saveFooter}>
                    Save Footer
                </button>
            </div>
        </div>
    );
}

export default FooterSetting;
